import { redirectToDashboard } from "@/helpers/navigation/navigation.helpers";
import { useAuthenticationState } from "@/hooks/useAuthenticationState/useAuthenticationState";
import { AUTHENTICATION_STATUS } from "@/providers/AuthenticationProvider/AuthenticationProvider.decl";
import { useEffect } from "react";
import { RequireAuthProps } from "./RequireAuth.decl";

export function RequireAuth({ children }: RequireAuthProps) {
  const {
    authState: { status },
  } = useAuthenticationState();

  useEffect(() => {
    if (status === AUTHENTICATION_STATUS.NOT_AUTHENTICATED) {
      redirectToDashboard(`/login?redirect=${window.location.href}`);
    }
  }, [status]);

  if (status !== AUTHENTICATION_STATUS.AUTHENTICATED) {
    return null;
  }

  return children;
}
